
import React from "react";
import { FormField } from "@/components/dashboard/shops/types";
import { Switch } from "@/components/ui/switch";

interface FieldToggleProps {
  field: FormField;
  isEditing: boolean;
  toggleFieldEnabled: (id: string) => void;
}

export const FieldToggle: React.FC<FieldToggleProps> = ({
  field,
  isEditing,
  toggleFieldEnabled
}) => {
  // Vérifier si c'est un champ téléphone (ne peut pas être désactivé)
  const isPhoneField = field.type === 'phone' || 
                     field.name === 'customerPhone' || 
                     field.name === 'Téléphone' ||
                     field.name.toLowerCase().includes('phone') || 
                     field.name.toLowerCase().includes('téléphone');
                     
  // Toujours activé pour les champs de téléphone
  const isEnabled = isPhoneField ? true : field.enabled;
  
  if (isEditing) {
    return (
      <Switch 
        checked={isEnabled}
        onCheckedChange={() => !isPhoneField && toggleFieldEnabled(field.id)}
        disabled={isPhoneField}
      />
    );
  }

  return (
    <div className={`w-2 h-2 rounded-full ${isEnabled ? 'bg-green-500' : 'bg-gray-300'}`} />
  );
};
